// extracted by mini-css-extract-plugin
module.exports = {"chosenValue":"TabLabel__chosenValue--1BAdE","icon":"TabLabel__icon--1a3EH","sidePad":"TabLabel__sidePad--3gQ00"};